import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { productQueryOptions, variantsQueryOptions } from '@/features/products';
import {
  storePricingQueryOptions,
  storeProductQueryOptions,
  StoreVariantPage,
} from '@/features/store-catalog';

export const Route = createFileRoute(
  '/_authed/_active/s/$storeId/catalog/$storeProductId_/variants/$variantId',
)({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, params }) => {
    const row = await context.queryClient.query({
      ...storeProductQueryOptions(params.storeId, params.storeProductId),
      staleTime: 'static',
    });
    const [, variants] = await Promise.all([
      context.queryClient.query({ ...productQueryOptions(row.productId), staleTime: 'static' }),
      context.queryClient.query({ ...variantsQueryOptions(row.productId), staleTime: 'static' }),
      context.queryClient
        .query({
          ...storePricingQueryOptions(params.storeId, params.storeProductId),
          staleTime: 'static',
        })
        .catch(() => undefined),
    ]);
    const variant = variants.find((v) => v.id === params.variantId);
    const title = row.title ?? row.product.title;
    return { crumb: variant ? `${title} · ${variant.title}` : title };
  },
  component: StoreVariantPage,
});
